import { SessionStateService } from '@abp/ng.core';
import { AbpOAuthService } from '@abp/ng.oauth';
import { Injectable, Injector } from '@angular/core';
import { Params } from '@angular/router';

@Injectable()
export class SitePlantAuthService extends AbpOAuthService {
	constructor(private readonly serviceInjector: Injector) {
		super();
	}

	override logout(queryParams?: Params) {

		this.serviceInjector.get(SessionStateService).setTenant(null);

		return super.logout(queryParams);
	}
}
